module.exports = __webpack_public_path__ + "static/media/3C.4281c3d1.svg";